import React, { FC, memo, ReactNode } from 'react';

interface SelectSizeAndBoxSectionProps {
  children: ReactNode;
  className?: string;
}

export const SelectSizeAndBoxSection: FC<SelectSizeAndBoxSectionProps> = memo((props) => {
  const { children, className = '' } = props;

  return <div className={`bg-white rounded-lg ${className}`}>{children}</div>;
});
